export const PC_PROCESSING = {
  PC_RETURN: 'pc_return',
  PC_RETURN_UNKNOWN: 'pc_return_unknown',
  PC_REFRESH: 'pc_refresh',
  PC_LOST_STOLEN: 'pc_lost_stolen',
  PC_ORDER: 'new_device',
  PC_REGISTER_DEVICE: 'register_device',
  PC_BREAK_FIX: 'pc_break_fix',
  PC_ACKNOWLEDGE_DEVICE: 'pc_acknowledge_device',
  PC_ASSIGNMENT_ERROR: 'pc_assignment_error',
  VD_REQUEST: 'vda_request',
  VA_REQUEST: 'va_request',
};

export enum EXCEPTION_TYPE {
  EXCEPTION = 'EXCEPTION_REQUIRED',
  RECOMMENDED = 'RECOMMENDED'
};

export enum APPROVAL_REQUIRED {
  YES = 'yes',
  NO = 'no'
};

export enum DISPATCH_MODE {
  SHIP = 'ship',
  PICKUP_FROM_DEPOT = 'pickup_from_depot',
  HAND_OVER_TO_VENDOR = 'hand_over_to_vendor',
  DROP_AT_DEPOT = 'drop_at_depot',
};

export enum PHONE_TYPE {
  MOBILE = 'Mobile',
  HOME = 'Home',
  WORK = 'Work'
};

export enum REQUESTED_DEVICE_TYPE {
  RECOMMENDED = 'recommended',
  EXCEPTIONAL_IN_STOCK = 'exceptional_in_stock',
  EXCEPTIONAL_BUY = 'exceptional_buy',
};

export const DEFAULT_EMPLOYEE_TYPE = 'Employee';
export const DEFAULT_PHONE_TYPE = 'Home';
export const NOT_AVAILABLE_MODEL_DEVICE = 'NOT_AVAILABLE_MODEL_DEVICE';

export const NEW_DEVICE_REQUEST_CANCEL_REASONS = 'NEW_DEVICE_REQUEST_CANCEL_REASONS';